import React from "react";
import user from "./img/user.png";
import calender from "./img/calender.png";
import { team } from "./data";
import { NavLink } from "react-router-dom";

const About = () => {
  return (
    <>
      <section id="team" className="py-8 bg-[]">
        <div className="container mx-auto text-center">
          {/* about us grid*/}
          <div className="lg:grid lg:grid-cols-2 lg:gap-x-[30px]">
            {team.map((item, index) => {
              const { image, name, description, link, date, more, href } = item;
              return (
                <div className="text-center lg:text-left mb-12 rounded-3xl bg-[#FFE0E0] py-[10px]" key={index}>
                  <img className="mx-auto mt-5 h-auto w-2/3 lg:mx-0 mb-6" src={image} alt="" />
                  <h4 className="text-2xl mb-2 text-[#CD5C5C] font-bold">{name}</h4>
                  <p className="max-w-[332px] text-[#F08080] lg:max-w-[350px] mx-auto lg:mx-0">
                    {description}
                  </p>
                  <div className="flex flex-wrap justify-center sm:justify-between md:justify-evenly">
                    <button className="bg-[#F6AFAF] text-[#AE4747] rounded-3xl w-40 mb-3 md:mb-0 md:mr-3">
                      <i className="fa-solid fa-user"></i>{link}
                    </button>
                    <button className="bg-[#F6AFAF] text-[#AE4747] rounded-3xl w-40 mb-3 md:mb-0 md:mx-3">
                      <i className="fa-solid fa-calendar"></i>{date}
                    </button>
                    <NavLink to={href}>
                      <button className="bg-[#F6AFAF] text-[#AE4747] rounded-3xl w-40 md:text-lg">
                        {more}
                      </button>
                    </NavLink>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default About;